import React from 'react';
import { Navigate } from 'react-router-dom';

function PrivateRouteAdmin({ children }) {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/admin/login" />;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.role === 'admin' ? children : <Navigate to="/login" />;
  } catch (e) {
    return <Navigate to="/admin/login" />;
  }
}


export default PrivateRouteAdmin;
